import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 9v4H6V9H4v6h16V9h-2z"
}), 'SpaceBarSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SpaceBarSharp.js
// module id = 6331
// module chunks = 2